<nz-skeleton *ngIf="!configData" [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="!configData">
</nz-skeleton>
<ng-container *ngIf="configData">

  <div class="card-container">
    <app-transaction-summary-ribbon [state]="mapperTransactionState" [policyData]="payloadInEdit"
      (documentManagerHandler)="documentManagerHandler($event)">
    </app-transaction-summary-ribbon>
  </div>

  <div *ngIf="mapperTransactionState == 'proposal_ManualUw'">
    <app-ui-accordion-small [dataList]="productSpecificationList" [title]="'Exclusions'" [toggleFor]="'exclusions'"
      [IO]="payloadInEdit">
    </app-ui-accordion-small>
  </div>

  <div class="m-t-10" *ngIf="mapperTransactionState == 'proposal_ManualUw'">
    <app-ui-accordion-small [dataList]="productSpecificationList" [title]="'Terms and Conditions'" [toggleFor]="'tAndc'"
      [IO]="payloadInEdit">
    </app-ui-accordion-small>
  </div>

  <!--<p>
  <a (click)="docuPanel(1)"><i class="anticon anticon-paper-clip"></i> Documents</a>
</p>-->

  <!-- Pending Tasks ? -->
  <div class="m-t-20" *ngIf="state=='adjudication'">
    <span class="clickable" (click)="pendingPanel(1)">
      <nz-alert nzType="warning" nzCloseable nzMessage="2 ongoing tasks for this claim" nzShowIcon>
      </nz-alert>
    </span>
  </div>

  <!-- Comments -->
  <div class="m-t-20" *ngIf="state=='adjudication'">

    <div class="ant-alert ant-alert-info ant-alert-with-description" *ngIf="showLastNote">
      <i class="ant-alert-icon anticon anticon-read"></i>

      <span class="ant-alert-message">
        Note from <b>Ryan Reynolds [Adjudicator]</b>
      </span>
      <span class="ant-alert-description">
        <small class="d-b m-b-10">2 April 2019 at 3:30 PM (1 day ago)</small>
        Please verify document proofs submitted. Especially the bills from Sacred Hearts Hospital.
      </span>
      <div class="p-t-10 d-b">
        <a (click)="notesPanel(1)">View all Notes</a>
        &nbsp;
        <a (click)="showLastNote=false;">Close</a>
      </div>
    </div>

  </div>

  <!-- Tabs -->
  <div class="m-t-20">

    <!--
    <nz-radio-group [(ngModel)]="nzTabPosition" style="float:right;">
      <label nz-radio-button [nzValue]="'top'">Horizontal</label>
      <label nz-radio-button [nzValue]="'left'">Vertical</label>
    </nz-radio-group>
  -->

    <nz-tabset [class.inputs-are-disabled]="mapperTransactionState == 'claimUWReferral' ||
  mapperTransactionState == 'claimReinsReferral'" style="height:auto" [nzTabPosition]="nzTabPosition"
      [(nzSelectedIndex)]="selectedIndex" (nzSelectChange)="log([$event])">

      <!-- INVESTIGATION (STATIC) Owner: Ganesh-->
      <nz-tab [nzTitle]="titleTmplBasicInvest" *ngIf="getTabVisibilityStatus('InvestigationDetails')">
        <ng-template #titleTmplBasicInvest>
          <i nz-icon nzType="safety"></i> Investigation Report
        </ng-template>

        <div class="tab-investigation" [ngClass]="{'inputs-are-disabled': !permissions.investigation_report.edit}">

          <!-- Tabset for TWO INVESTIGATORS -->
          <nz-tabset style="height:auto" [nzSize]="'large'">

            <nz-tab [nzTitle]="titleTmplInvestigator1">
              <ng-template #titleTmplInvestigator1>
                <strong class="d-b">Investigator 2: Elliot Henderson (YOU!)</strong>
                <p class="col-grey-dark m-b-5">
                  Investigation ongoing
                </p>
              </ng-template>

              <div>
                <div class="tab-investigation"
                  [ngClass]="{'inputs-are-disabled': !permissions.investigation_report.edit}">

                  <!-- Investigation Items -->

                  <div class="investigation-item">
                    <div class="heading-tab">
                      <h3 class="heading"><i nz-icon nzType="file-unknown"></i> Investigation Item I: Hospital Records
                      </h3>
                    </div>
                    <div class="flexie-auto-grid">
                      <div class="flex-self-vert-start">
                        <h4 class="p-b-10">Observations</h4>
                        <textarea nz-input cols="30" rows="6" placeholder="Enter your observations..."></textarea>
                      </div>
                      <div class="flex-self-vert-start">
                        <h4 class="p-b-10">Supporting Documents <a (click)="docuPanel(1)">[Manage]</a></h4>
                        <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/" nzListType="picture-card"
                          [(nzFileList)]="defaultUploadsList" [nzShowButton]="defaultUploadsList.length < 3"
                          [nzShowUploadList]="showUploadList">
                          <i nz-icon nzType="plus" nzTheme="outline"></i>
                          <div class="ant-upload-text">Upload</div>
                        </nz-upload>
                      </div>
                    </div>
                  </div>
                  <div class="investigation-item">
                    <div class="heading-tab">
                      <h3 class="heading"><i nz-icon nzType="file-unknown"></i> Investigation Item II: Death Certificate
                      </h3>
                    </div>
                    <div class="flexie-auto-grid">
                      <div class="flex-self-vert-start">
                        <h4 class="p-b-10">Observations</h4>
                        <textarea nz-input cols="30" rows="6" placeholder="Enter your observations..."></textarea>
                      </div>
                      <div class="flex-self-vert-start">
                        <h4 class="p-b-10">Supporting Documents <a (click)="docuPanel(1)">[Manage]</a></h4>
                        <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/" nzListType="picture-card"
                          [(nzFileList)]="defaultUploadsList" [nzShowButton]="defaultUploadsList.length < 3"
                          [nzShowUploadList]="showUploadList">
                          <i nz-icon nzType="plus" nzTheme="outline"></i>
                          <div class="ant-upload-text">Upload</div>
                        </nz-upload>
                      </div>
                    </div>
                  </div>

                  <!-- Overall Summary -->

                  <div class="heading-tab">
                    <h3 class="heading"><i nz-icon nzType="file-text"></i> Overall summary of investigation</h3>
                  </div>

                  <div class="flexie-auto-grid">
                    <!-- Summary Textbox -->
                    <div class="flex-self-vert-start">
                      <h3 class="heading">Summary</h3>
                      <textarea nz-input cols="30" rows="6" placeholder="Enter your summary ..."></textarea>
                    </div>
                    <!-- Summary : Final Verdict -->
                    <div class="flex-self-vert-start">
                      <h3 class="heading">Verdict / Final Recommendation</h3>

                      <nz-radio-group [(ngModel)]="investiVerdict">
                        <span class="d-b p-t-b-10">
                          <label nz-radio nzValue="A"><span class="f-w-600 col-green">OK to proceed</span></label>
                        </span>
                        <!--<span class="d-b p-t-b-10">
                      <label nz-radio
                             nzValue="B"><span class="f-w-600 col-orange">Proceed with caution / More investigation
                        required</span></label>
                      </span>-->
                        <span class="d-b p-t-b-10">
                          <label nz-radio nzValue="C"><span class="f-w-600 col-red">Do not proceed</span></label>
                        </span>
                        <!--<span class="d-b p-t-b-10">
                      <label nz-radio nzValue="O">
                        Other...
                        <input type="text" nz-input *ngIf="investiVerdict == 'O'" style="width: 100px; margin-left: 10px;" />
                      </label>
                      </span>-->
                      </nz-radio-group>
                    </div>
                  </div>

                </div>
              </div>

            </nz-tab>

            <nz-tab [nzTitle]="titleTmplInvestigator2">
              <ng-template #titleTmplInvestigator2>
                <strong class="d-b">Investigator 1: Kevin Fergie</strong>
                <p class="col-green m-b-5">
                  Investigation Complete
                </p>
              </ng-template>

              <div class="inputs-are-disabled">
                <div class="tab-investigation"
                  [ngClass]="{'inputs-are-disabled': !permissions.investigation_report.edit}">

                  <!-- Investigation Items -->

                  <div class="investigation-item">
                    <div class="heading-tab">
                      <h3 class="heading"><i nz-icon nzType="file-unknown"></i> Investigation Item I: Hospital Records
                      </h3>
                    </div>
                    <div class="flexie-auto-grid">
                      <div class="flex-self-vert-start">
                        <h4 class="p-b-10">Observations</h4>
                        <textarea nz-input cols="30" rows="6" placeholder="Enter your observations..."></textarea>
                      </div>
                      <div class="flex-self-vert-start">
                        <h4 class="p-b-10">Supporting Documents <a (click)="docuPanel(1)">[Manage]</a></h4>
                        <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/" nzListType="picture-card"
                          [(nzFileList)]="defaultUploadsList" [nzShowButton]="defaultUploadsList.length < 3"
                          [nzShowUploadList]="showUploadList">
                          <i nz-icon nzType="plus" nzTheme="outline"></i>
                          <div class="ant-upload-text">Upload</div>
                        </nz-upload>
                      </div>
                    </div>
                  </div>
                  <div class="investigation-item">
                    <div class="heading-tab">
                      <h3 class="heading"><i nz-icon nzType="file-unknown"></i> Investigation Item II: Death Certificate
                      </h3>
                    </div>
                    <div class="flexie-auto-grid">
                      <div class="flex-self-vert-start">
                        <h4 class="p-b-10">Observations</h4>
                        <textarea nz-input cols="30" rows="6" placeholder="Enter your observations..."></textarea>
                      </div>
                      <div class="flex-self-vert-start">
                        <h4 class="p-b-10">Supporting Documents <a (click)="docuPanel(1)">[Manage]</a></h4>
                        <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/" nzListType="picture-card"
                          [(nzFileList)]="defaultUploadsList" [nzShowButton]="defaultUploadsList.length < 3"
                          [nzShowUploadList]="showUploadList">
                          <i nz-icon nzType="plus" nzTheme="outline"></i>
                          <div class="ant-upload-text">Upload</div>
                        </nz-upload>
                      </div>
                    </div>
                  </div>

                  <!-- Overall Summary -->

                  <div class="heading-tab">
                    <h3 class="heading"><i nz-icon nzType="file-text"></i> Overall summary of investigation</h3>
                  </div>

                  <div class="flexie-auto-grid">
                    <!-- Summary Textbox -->
                    <div class="flex-self-vert-start">
                      <h3 class="heading">Summary</h3>
                      <textarea nz-input cols="30" rows="6" placeholder="Enter your summary ..."></textarea>
                    </div>
                    <!-- Summary : Final Verdict -->
                    <div class="flex-self-vert-start">
                      <h3 class="heading">Verdict / Final Recommendation</h3>

                      <nz-radio-group [(ngModel)]="investiVerdict">
                        <span class="d-b p-t-b-10">
                          <label nz-radio nzValue="A"><span class="f-w-600 col-green">OK to proceed</span></label>
                        </span>
                        <!--<span class="d-b p-t-b-10">
                      <label nz-radio
                             nzValue="B"><span class="f-w-600 col-orange">Proceed with caution / More investigation
                        required</span></label>
                      </span>-->
                        <span class="d-b p-t-b-10">
                          <label nz-radio nzValue="C"><span class="f-w-600 col-red">Do not proceed</span></label>
                        </span>
                        <!--<span class="d-b p-t-b-10">
                      <label nz-radio nzValue="O">
                        Other...
                        <input type="text" nz-input *ngIf="investiVerdict == 'O'" style="width: 100px; margin-left: 10px;" />
                      </label>
                      </span>-->
                      </nz-radio-group>
                    </div>
                  </div>

                </div>
              </div>

            </nz-tab>

          </nz-tabset>

        </div>

      </nz-tab>

      <!-- TODO ninad transaction tabs start  -->
      <!-- BASIC DETAILS -->
      <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('BasicDetails')"
        (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
        <ng-template #titleTmplBasicDtl>
          <i nz-icon nzType="file-protect"></i> Basic Details
        </ng-template>
        <!-- <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'">

          <app-submission-data [inputDataForEdit]="_inputSubmissionDataComponent"
            [DOName]="_getDOName(TransactionState)" [transactionState]="mapperTransactionState"
            [proposalType]="proposalType" [configData]="configData" [product]="selectedProduct"
            [productFamilyCd]="productFamilyCd" (policyPackageType)="getPackageType($event)"
            (componentOutput)="_BaseEmitHandler($event, 'SubmissionDataComponent')">
          </app-submission-data>

          <app-captured-client-list captureRole="OWNER" (clientEmitterToCopy)="updateClientList($event,'OWNER')"
            [allowClientToBeCopied]="TRUEVALUE" [allowEditInsured]="FALSEVALUE" [operationMode]="SINGLE"
            [clientList]="ownerDataSet" [enableClientAsPayer]="TRUEVALUE"
            (openSearchModal)="editClient('modSearchCustomerOwner', $event)" [transactionState]="mapperTransactionState"
            [allowedCount]="noOfClientsCanBeAdded.PH"
            (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentOWNER')"
            (emittedClient)="_EmittedClientHandler($event, 'PRIMARYINSURED')"
            [inputDataForEdit]="_inputAllClientListComponent">
          </app-captured-client-list>
        </div> -->

        
        <app-dynamic-form [baseDOName]="configData.StateToDOMapper[mapperTransactionState]"
        FORMTITLE="Basic Details" FORMNAME="underwritingDecisionForm" [IO]="payloadInEdit"
        (componentOutput)="_BaseEmitHandler($event, 'PolicyServicingBasicDetailsComponent')"
        [currentComponentName]="'PolicyServicingBasicDetailsComponent'"
        [formMetaData]="configData.ComponentMetaDataConfiguration.PolicyServicingBasicDetailsComponent">
      </app-dynamic-form>

      </nz-tab>

      <!-- Policy servicing - Policy Details -->
      <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('PolicyDetailsComponent')"
        (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
        <ng-template #titleTmplBasicDtl>
          <i nz-icon nzType="file-protect"></i> Policy Details
        </ng-template>

        <app-dynamic-form [baseDOName]="configData.StateToDOMapper[mapperTransactionState]"
        FORMTITLE="Basic Details" FORMNAME="underwritingDecisionForm" [IO]="payloadInEdit"
        (componentOutput)="_BaseEmitHandler($event, 'PolicyServicingBasicDetailsComponent')"
        [currentComponentName]="'PolicyServicingBasicDetailsComponent'"
        [formMetaData]="configData.ComponentMetaDataConfiguration.PolicyServicingBasicDetailsComponent">
      </app-dynamic-form>

      </nz-tab>

      <!-- CUSTOMER DETAILS -->
<!-- Tab 1 -->
      <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('CustomerDetailsComponent')"
        (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
        <ng-template #titleTmplBasicDtl>
          <i nz-icon nzType="file-protect"></i> Customer Details
        </ng-template>

        <app-customer-dash></app-customer-dash>

        <app-dynamic-form [baseDOName]="configData.StateToDOMapper[mapperTransactionState]"
        FORMTITLE="Basic Details" FORMNAME="underwritingDecisionForm" [IO]="payloadInEdit"
        (componentOutput)="_BaseEmitHandler($event, 'CustomerDetailsComponent')"
        [currentComponentName]="'CustomerDetailsComponent'"
        [formMetaData]="configData.ComponentMetaDataConfiguration.CustomerDetailsComponent">
      </app-dynamic-form>

      <div class="heading-tab">
        <h3 class="heading"><i nz-icon nzType="file-unknown"></i> <span translate> Contact Details</span></h3>
      </div>
      <div class="flexie-auto-grid">
        <div class="flex-self-vert-start">
          <h4><i nz-icon nzType="mail" nzTheme="outline"></i> <span translate> Email</span></h4>
          <app-email-list-details [inputDataForEdit]="payloadInEdit"
            (componentOutput)="_BaseEmitHandler($event, 'EmailListDetailsComponent')">
          </app-email-list-details>
        </div>
        <div class="flex-self-vert-start">
          <h4><i nz-icon nzType="mobile" nzTheme="outline"></i> <span translate> Mobile</span></h4>
          <app-phone-list-details [inputDataForEdit]="payloadInEdit"
            (componentOutput)="_BaseEmitHandler($event, 'PhoneListDetailsComponent')">
          </app-phone-list-details>
        </div>
      </div>

      <div class="heading-tab">
        <h3 class="heading"><i nz-icon nzType="file-unknown"></i> <span translate> Address Details</span></h3>
      </div>
      <div>
        <ui-address-ind (componentOutput)="fetchAddressList($event)"
          [inputDataForEdit]="inputClientCaptureAddressDetailsList"></ui-address-ind>
      </div>

      </nz-tab>


<!-- Tab 2 -->
      <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('PoliciesComponent')"
        (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
        <ng-template #titleTmplBasicDtl>
          <i nz-icon nzType="file-protect"></i> Policies
        </ng-template>

        <app-dynamic-form [baseDOName]="configData.StateToDOMapper[mapperTransactionState]"
        FORMTITLE="Basic Details" FORMNAME="underwritingDecisionForm" [IO]="payloadInEdit"
        (componentOutput)="_BaseEmitHandler($event, 'PolicyServicingBasicDetailsComponent')"
        [currentComponentName]="'PolicyServicingBasicDetailsComponent'"
        [formMetaData]="configData.ComponentMetaDataConfiguration.PolicyServicingBasicDetailsComponent">
      </app-dynamic-form>

      </nz-tab>


<!-- Tab 3 -->
<nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('ClaimsDetailsComponent')"
(nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
<ng-template #titleTmplBasicDtl>
  <i nz-icon nzType="file-protect"></i> Claims
</ng-template>

<app-dynamic-form [baseDOName]="configData.StateToDOMapper[mapperTransactionState]"
FORMTITLE="Basic Details" FORMNAME="underwritingDecisionForm" [IO]="payloadInEdit"
(componentOutput)="_BaseEmitHandler($event, 'PolicyServicingBasicDetailsComponent')"
[currentComponentName]="'PolicyServicingBasicDetailsComponent'"
[formMetaData]="configData.ComponentMetaDataConfiguration.PolicyServicingBasicDetailsComponent">
</app-dynamic-form>

</nz-tab>

<!-- Tab 4 -->
<nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('ServiceRequestDetailsComponent')"
(nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
<ng-template #titleTmplBasicDtl>
  <i nz-icon nzType="file-protect"></i> Service Request
</ng-template>

<app-dynamic-form [baseDOName]="configData.StateToDOMapper[mapperTransactionState]"
FORMTITLE="Basic Details" FORMNAME="underwritingDecisionForm" [IO]="payloadInEdit"
(componentOutput)="_BaseEmitHandler($event, 'PolicyServicingBasicDetailsComponent')"
[currentComponentName]="'PolicyServicingBasicDetailsComponent'"
[formMetaData]="configData.ComponentMetaDataConfiguration.PolicyServicingBasicDetailsComponent">
</app-dynamic-form>

</nz-tab>



    </nz-tabset>
  </div>
  <!-- Save/Actions Footer -->

  <!-- <div *ngIf="productTypeConfig.productType=='newbusiness'"> -->
  <div>
    <div class="card-summary-data-footer __data-footer-primary">
      <div>
        <!-- LHS -->
      </div>
      <div>
        <button nz-button class="m-r-10" [nzType]="'success'" [disabled]="!dataSubmittedFlag" (click)="attemptForTransaction('submit')">Submit</button>
        <button nz-button class="m-r-10" [nzType]="'primary'" [disabled]="!dataSubmittedFlag" (click)="attemptForTransaction('save')">Save</button>
      </div>
    </div>
  </div>

  <!-- TODO ninad transaction tabs end  -->
  <div
    *ngIf="((payloadInEdit && payloadInEdit['exceptionDOList'] && payloadInEdit['exceptionDOList'].length > 0) || (_UIErrorList && _UIErrorList.length > 0))"
    class="error-panel" [ngClass]="{'error-panel-collapsed': errPanelCollapsed}">

    <!-- Heading -->
    <div class="flexie-auto-grid clickable p-b-5" (click)="errorPanelToggle()">
      <div>
        <h4 class="col-red">Exceptions</h4>
      </div>
      <div class="text-a-right d-b">
        <i *ngIf="!errPanelCollapsed" class="anticon anticon-down"></i>
        <i *ngIf="errPanelCollapsed" class="anticon anticon-up"></i>
      </div>
    </div>

    <!-- Errors List -->
    <div>
      <ng-container
        *ngIf="payloadInEdit && payloadInEdit['exceptionDOList'] && payloadInEdit['exceptionDOList'].length > 0">

        <strong class="col-grey-dark">Validation Exceptions</strong>
        <ul class="error-list">
          <li *ngFor="let exception of payloadInEdit['exceptionDOList']">
            <span>{{exception?.exceptionType}} : {{exception?.exceptionMessage}}</span>
          </li>
          <div
            *ngIf="payloadInEdit && payloadInEdit['exceptionDOList'] && payloadInEdit['exceptionDOList'].length == 0">
            No
            Exceptions found</div>
        </ul>

      </ng-container>


      <ng-container *ngIf="_UIErrorList && _UIErrorList.length > 0">

        <strong class="col-grey-dark">Invalid Data</strong>
        <ul class="error-list">
          <li *ngFor="let error of _UIErrorList">
            <span>{{error?.fieldNameDescription}} : {{error?.errorMsg}}</span>
          </li>
          <div *ngIf="_UIErrorList && _UIErrorList.length == 0">No
            Exceptions found</div>
        </ul>

      </ng-container>

      <!-- <strong class="col-grey-dark">Business Exceptions</strong>
    <ul class="error-list">
      <div>No Exceptions found</div>
    </ul> -->
    </div>

    <!-- View all -->
    <!-- <a (click)="errDetailsPanel(1)" class="d-b col-grey-dark p-t-b-5 b-1 text-a-center">View All</a> -->

  </div>


  <!-- MODALS -->

  <nz-modal [(nzVisible)]="emitterStatusModal" nzTitle="Component Emitter Log" nzCancelDisabled
    (nzOnOk)="emitterStatusModal = !emitterStatusModal" nzWidth="1000px">
    <nz-table #emitterTable [nzData]="emitterStatusForView">
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th>Name</th>
          <th>Emitted</th>
          <th>IsExtra</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of emitterTable.data; let i = index">
          <td>{{i+1}}</td>
          <td>{{data?.componentName}}</td>
          <td>{{data?.emitted? 'Working' : 'Not Working' }}</td>
          <td>{{data?.emitted && data?.isExtra? 'Remove from StateToChildComponentMapper': 'No' }}</td>
        </tr>
      </tbody>
    </nz-table>
  </nz-modal>

  <nz-modal [(nzVisible)]="modInvtgVis" [nzTitle]="modalTitle" (nzOnCancel)="modInvtgVis=false" (nzOnOk)="refertoUser()"
    nzOkText="Refer" nzWidth="600px">
    <div *ngIf="modInvtgVis">

      <div class="flex flex-horiz-space-bw">
        <h4>Enter your Notes</h4>
        <nz-dropdown *ngIf="reffrelUserType == 'INVESTIGATOR'" [nzPlacement]="'bottomRight'">
          <a nz-dropdown class="col-grey-dark">Canned Replies <i nz-icon nzType="down"></i></a>
          <ul nz-menu>
            <li nz-menu-item (click)="noteCannedReply(0)">Please have a look at the ...</li>
            <li nz-menu-item (click)="noteCannedReply(1)">Requesting additional investigation ...</li>
            <li nz-menu-item (click)="noteCannedReply(2)">Required Documents are not in place ...</li>
            <nz-divider class="dd-extra-hr"></nz-divider>
            <li nz-menu-item>Manage Canned Replies</li>
          </ul>
        </nz-dropdown>
      </div>
      <textarea *ngIf="reffrelUserType == 'INVESTIGATOR'" rows="2" nz-input [(ngModel)]="note"></textarea>
      <textarea *ngIf="reffrelUserType != 'INVESTIGATOR'" rows="5" nz-input [(ngModel)]="note"></textarea>

      <h4 class="d-b m-t-20" *ngIf="reffrelUserType == 'INVESTIGATOR'">Investigate:</h4>
      <nz-select nzShowSearch nzMode="tags" *ngIf="reffrelUserType == 'INVESTIGATOR'" style="width: 100%;"
        [ngModel]="'Hospital Records'">
        <nz-option nzLabel="Hospital Records" nzValue="Hospital Records"> </nz-option>
        <nz-option nzLabel="Death Certificate" nzValue="Death Certificate"> </nz-option>
        <nz-option nzLabel="Cross-check with Doctor" nzValue="Cross-check with Doctor"> </nz-option>
      </nz-select>


      <h4 class="d-b m-t-20" *ngIf="reffrelUserType == 'INVESTIGATOR'">Attach Files/Documents</h4>

      <!-- Upload table -->
      <nz-table *ngIf="reffrelUserType == 'INVESTIGATOR'" #basicTable [nzData]="dataSet" [nzShowPagination]="false">
        <thead>
          <tr>
            <th>Type</th>
            <th>Comment</th>
            <th>Document</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Claim Form</td>
            <td>Please check this in detail</td>
            <td><a>fc_023_scan.pdf</a></td>
            <td>
              <!-- Actions -->
              <span class="m-r-10"><i nz-icon nzType="eye" nzTheme="outline"></i></span>
              <span><i class="anticon anticon-delete col-red"></i></span>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <a *ngIf="reffrelUserType == 'INVESTIGATOR'">Add more</a>



      <h4 class="d-b m-t-20">Assign to</h4>
      <!-- <nz-select nzShowSearch class="w-100-pc"  nzAllowClear nzPlaceHolder="Select a person">
      <nz-option nzLabel="Jack Nicholson (Golden Bay Area)" nzValue="1"></nz-option>
      <nz-option nzLabel="Lucy Liu (Hypercity Area)" nzValue="2"></nz-option>
      <nz-option nzLabel="Tom Hardy (New Delhi Area)" nzValue="3"></nz-option>
    </nz-select> -->
      <nz-select nzShowSearch id="eventType" style="width: 100%" [(ngModel)]="assigneeUser">
        <nz-option *ngFor="let item of (lookup$.csrUsersUID | async) as eventTypeCdLookup; trackBy:item?.lookupKey"
          [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupValue"></nz-option>
      </nz-select>
    </div>

  </nz-modal>

  <nz-modal [(nzVisible)]="modalCorrespNew" nzTitle="New Correspondence" (nzOnCancel)="modalCorrespNew=false"
    (nzOnOk)="modalCorrespNew=false" nzOkText="Send" nzWidth="75%" nzZIndex="=1400">
    <div *ngIf="modalCorrespNew">

      <nz-radio-group [(ngModel)]="correspType" [nzButtonStyle]="'solid'" [nzSize]="'default'">
        <label nz-radio-button nzValue="email"><i nz-icon nzType="mail" nzTheme="outline"></i> Email</label>
        <label nz-radio-button nzValue="sms"><i nz-icon nzType="mobile" nzTheme="outline"></i> SMS</label>
        <label nz-radio-button nzValue="pdf"><i nz-icon nzType="file-pdf" nzTheme="outline"></i> PDF</label>
      </nz-radio-group>


      <div *ngIf="'email'==correspType">
        <h4 class="d-b m-t-20">To</h4>
        <!-- Multi emails; ENTER to add new entry -->
        <nz-select nzShowSearch nzMode="tags" style="width: 100%;" [ngModel]="'liam@thehemsworths.com'">
          <nz-option nzLabel="liam@thehemsworths.com" nzValue="liam@thehemsworths.com"></nz-option>
          <nz-option nzLabel="chris@thehemsworths.com" nzValue="chris@thehemsworths.com"></nz-option>
          <nz-option nzLabel="robert@thehemsworths.com" nzValue="robert@thehemsworths.com"></nz-option>
        </nz-select>


        <h4 class="d-b m-t-20">Content</h4>

        <angular-editor [(ngModel)]="correspondenceRichText"></angular-editor>


        <h4 class="d-b m-t-20">Attach Files/Documents</h4>

        <!-- Upload table -->
        <nz-upload nzType="drag" [nzMultiple]="true" [nzLimit]="2"
          nzAction="https://jsonplaceholder.typicode.com/posts/" (nzChange)="handleFileUpload($event)">
          <p class="ant-upload-drag-icon">
            <i nz-icon nzType="inbox" class="anticon anticon-inbox"></i>
          </p>
          <p class="ant-upload-text">Click or drag file to this area to upload</p>
          <p class="ant-upload-hint">
            Support for a single or bulk upload. Strictly prohibited from uploading internal company data or other
            confidential data
          </p>
        </nz-upload>


      </div>

      <div *ngIf="'sms'==correspType">
        <h4 class="d-b m-t-20">To (Mobile Numbers)</h4>
        <!-- Multi phone nos; ENTER to add new entry -->
        <nz-select nzShowSearch nzMode="tags" style="width: 100%;" [ngModel]="'9800560098'">
          <nz-option nzLabel="9800560098" nzValue="9800560098"> </nz-option>
        </nz-select>

        <h4 class="d-b m-t-20">Message</h4>
        <textarea nz-input value=""></textarea>

      </div>
    </div>

  </nz-modal>

  <nz-modal [(nzVisible)]="modSubmit" nzTitle="Submit" (nzOnCancel)="modSubmit=false" (nzOnOk)="modSubmit=false"
    nzOkText="Submit">
    <div *ngIf="modSubmit">

      <h4>I have verified</h4>
      <span class="d-b p-t-b-10"><label nz-checkbox>Documents are in place</label></span>
      <span class="d-b p-t-b-10"><label nz-checkbox>Proofs matches with records</label></span>
      <span class="d-b p-t-b-10"><label nz-checkbox>Verified against discrepancies in claim</label></span>
      <span class="d-b p-t-b-10"><label nz-checkbox>Verified claim amount</label></span>

      <div class="m-t-20">
        <h4 class="d-i-b m-r-10">Logged in as</h4>
        <nz-avatar nzSize="small" nzIcon="user"></nz-avatar>&nbsp;
        John Doe
      </div>

    </div>



  </nz-modal>

  <!-- Search Policy or Client -->
  <nz-modal [(nzVisible)]="modSearchCustOrPolicy" nzTitle="Search / Add Policy"
    (nzOnCancel)="modSearchCustOrPolicy=false" (nzOnOk)="searchPolicyClientOk()" nzOkText="Add" nzWidth="75%">
    <app-generic-search *ngIf="modSearchCustOrPolicy" modalFlag="modSearchCustOrPolicy"
      searchMode="policySearchOnlyBasedOnClientOrPolicyData" (componentOutput)="getPolicyList($event)">
    </app-generic-search>
  </nz-modal>

  <!-- Search Client -->
  <nz-modal [nzFooter]="ClientCaptureFooter" [(nzVisible)]="modSearchNominee" nzTitle="Search / Add Nominee"
    (nzOnCancel)="modSearchNominee=false" nzWidth="75%">
    <app-generic-search *ngIf="modSearchNominee" modalFlag="modSearchNominee" searchMode="customerSearchOrCapture"
      captureRole="NOMINEE" (componentOutput)="getNominee($event)" [inputDataForEdit]="editClientData"
      (enableFooter)="setFooter($event)">
    </app-generic-search>
  </nz-modal>

  <!-- Search Primary Insured -->
  <nz-modal [nzFooter]="ClientCaptureFooter" [(nzVisible)]="modSearchCustomerPrimaryInsured"
    nzTitle="Search / Add Primary Insured" (nzOnCancel)="modSearchCustomerPrimaryInsured=false" nzWidth="75%">
    <app-generic-search *ngIf="modSearchCustomerPrimaryInsured" modalFlag="modSearchCustomerPrimaryInsured"
      searchMode="customerSearchOrCapture" captureRole="PRIMARYINSURED" [inputDataForEdit]="editClientData"
      (componentOutput)="getPrimaryInsured($event)" (enableFooter)="setFooter($event)">
    </app-generic-search>
  </nz-modal>

  <!-- Search Insured -->
  <nz-modal [nzFooter]="ClientCaptureFooter" [(nzVisible)]="modSearchCustomerInsured" nzTitle="Search / Add Insured"
    (nzOnCancel)="modSearchCustomerInsured=false" nzWidth="75%">
    <app-generic-search *ngIf="modSearchCustomerInsured" modalFlag="modSearchCustomerInsured"
      searchMode="customerSearchOrCapture" captureRole="INSURED" [inputDataForEdit]="editClientData"
      (componentOutput)="getInsured($event)" (enableFooter)="setFooter($event)"></app-generic-search>
  </nz-modal>

  <!-- Members -->
  <nz-modal [nzFooter]="ClientCaptureFooter" [(nzVisible)]="modSearchCustomerMembers" nzTitle="Search / Add Members"
    (nzOnCancel)="modSearchCustomerMembers=false" nzWidth="75%">
    <app-generic-search *ngIf="modSearchCustomerMembers" modalFlag="modSearchCustomerMembers"
      searchMode="customerSearchOrCapture" captureRole="MEMBERS" [inputDataForEdit]="editClientData"
      (componentOutput)="getMembers($event)" (enableFooter)="setFooter($event)"></app-generic-search>
  </nz-modal>

  <!-- Search Payer -->
  <nz-modal [nzFooter]="ClientCaptureFooter" [(nzVisible)]="modSearchCustomerPayer" nzTitle="Search / Add Payer"
    (nzOnCancel)="modSearchCustomerPayer=false" nzWidth="75%">
    <app-generic-search *ngIf="modSearchCustomerPayer" modalFlag="modSearchCustomerPayer"
      searchMode="customerSearchOrCapture" captureRole="PAYER" [inputDataForEdit]="editClientData"
      (componentOutput)="getPayer($event)" (enableFooter)="setFooter($event)"></app-generic-search>
  </nz-modal>

  <!-- Search Owner -->
  <nz-modal [nzFooter]="ClientCaptureFooter" [(nzVisible)]="modSearchCustomerOwner" nzTitle="Search / Add Policy Holder"
    (nzOnCancel)="modSearchCustomerOwner=false" nzWidth="75%">
    <app-generic-search *ngIf="modSearchCustomerOwner" modalFlag="modSearchCustomerOwner"
      searchMode="customerSearchOrCapture" captureRole="OWNER" [inputDataForEdit]="editClientData"
      (componentOutput)="getOwner($event)" (enableFooter)="setFooter($event)"></app-generic-search>
  </nz-modal>

  <!-- Search Vehicle -->
  <nz-modal [nzFooter]="ClientCaptureFooter" [(nzVisible)]="modSearchCustomerVehicle" nzTitle="Search / Add Vehicle"
    (nzOnCancel)="modSearchCustomerVehicle=false" nzWidth="75%">
    <app-generic-search *ngIf="modSearchCustomerVehicle" modalFlag="modSearchCustomerVehicle"
      searchMode="customerSearchOrCapture" captureRole="VEHICLE" (componentOutput)="getVehicle($event)"
      (enableFooter)="setFooter($event)"></app-generic-search>
  </nz-modal>


  <!-- Serch Claimant -->
  <nz-modal [nzFooter]="ClientCaptureFooter" [(nzVisible)]="modSearchCustomerClaimant" nzTitle="Search / Add Claimant"
    (nzOnCancel)="modSearchCustomerClaimant=false" (nzOnOk)="pingToClientSearchForClaimant()" nzOkText="Select"
    nzWidth="75%">
    <app-generic-search *ngIf="modSearchCustomerClaimant" modalFlag="modSearchCustomerClaimant"
      searchMode="customerSearchOrCapture" captureRole="CLAIMANT" (componentOutput)="getClaimant($event)"
      (enableFooter)="setFooter($event)">
    </app-generic-search>
  </nz-modal>

  <!-- Search Agent -->
  <nz-modal [(nzVisible)]="modSearchAgent" nzTitle="Search Intermediary" (nzOnCancel)="modSearchAgent=false"
    (nzOnOk)="pingToAgentSearchForData()" nzOkText="Select" nzWidth="75%">
    <app-generic-search *ngIf="modSearchAgent" modalFlag="modSearchAgent" searchMode="customerSearchOnly"
      captureRole="AGENT" (componentOutput)="getAgent($event)" (enableFooter)="setFooter($event)">
    </app-generic-search>
  </nz-modal>



  <!-- Rejection -->
  <nz-modal [(nzVisible)]="modRejectIntimation" nzTitle="Reject Intimation" (nzOnCancel)="modRejectIntimation=false"
    (nzOnOk)="modRejectIntimation=false" nzOkText="Reject" nzWidth="600px">
    <div *ngIf="modRejectIntimation">

      <div class="flex flex-horiz-space-bw">
        <h4>Reason for Rejection</h4>
        <nz-dropdown [nzPlacement]="'bottomRight'">
          <a nz-dropdown class="col-grey-dark">Canned Replies <i nz-icon nzType="down"></i></a>
          <ul nz-menu>
            <li nz-menu-item (click)="noteCannedReply(2)">Required Documents are not in place ...</li>
            <nz-divider class="dd-extra-hr"></nz-divider>
            <li nz-menu-item>Manage Canned Replies</li>
          </ul>
        </nz-dropdown>
      </div>
      <textarea rows="2" nz-input [(ngModel)]="note"></textarea>

    </div>

  </nz-modal>






  <!-- Hidden Content -- DRAWERS -->
  <!-- CORRESPONDENCE -->
  <nz-drawer [nzClosable]="true" [nzWidth]="390" [nzPlacement]="'right'" nzTitle="Correspondence with `Chris Hemsworth`"
    [nzVisible]="corresPanelOpen" (nzOnClose)="corresPanel(0)">
    <div>

      <div class="p-b-10 flex flex-horiz-space-bw">
        <div></div>
        <button nz-button nzType="primary" (click)="openCorrModal()">New Correspondence</button>
      </div>

      <nz-timeline>
        <nz-timeline-item nzColor="green">
          <h4 class="f-w-600">eMail <nz-tag [nzColor]="'green'">Sent</nz-tag>
          </h4>
          <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
          <p>
            To: riya@gmail.com <br>
            Message: Your proposal is being processed <br>
            Attachment: <a>P0000107.EML</a>
          </p>
        </nz-timeline-item>
        <nz-timeline-item nzColor="green">
          <h4 class="f-w-600">SMS <nz-tag [nzColor]="'green'">Sent</nz-tag>
          </h4>
          <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
          <p>
            To: 9809862272 <br />
            Message: Your proposal is being processed
          </p>
        </nz-timeline-item>
      </nz-timeline>
    </div>
  </nz-drawer>

  <!-- DOCUMENT PANEL // DOCUMENT MANAGER -->
  <nz-drawer [nzClosable]="true" [nzWidth]="460" [nzPlacement]="'right'" nzTitle="Document Manager"
    [nzVisible]="docuPanelOpen" (nzOnClose)="docuPanel(0)">
    <div>
      <app-document-manager [requirements]="_inputDocumentManagerComponent['requirementDOs']"
        [inputDataForEdit]="_inputDocumentManagerComponent['entityDocumentDOs']"
        [RequirementEntityGuid]="transactionGuid" coreComponent=true
        (componentOutput)="_BaseEmitHandler($event, 'DocumentManagerComponent')">
      </app-document-manager>
    </div>
  </nz-drawer>

  <!-- PENDING TASKS -->
  <nz-drawer [nzClosable]="true" [nzWidth]="390" [nzPlacement]="'right'" nzTitle="Pending Tasks for #CLM0000107"
    [nzVisible]="pendingPanelOpen" (nzOnClose)="pendingPanel(0)">

    <div *ngIf="pendingPanelOpen">

      <nz-timeline>
        <nz-timeline-item nzColor="orange">
          <h4 class="f-w-600">Investigation <nz-tag [nzColor]="'orange'">Pending</nz-tag>
          </h4>
          <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
          <p>
            Investigator: G. Fadango <br>
            Status: Being Investigated
          </p>
        </nz-timeline-item>
        <nz-timeline-item nzColor="orange">
          <h4 class="f-w-600">Missing Document <nz-tag [nzColor]="'orange'">Pending</nz-tag>
          </h4>
          <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
          <p>
            Notes: Correspondence sent to Claimant
          </p>
        </nz-timeline-item>
      </nz-timeline>

    </div>


  </nz-drawer>
</ng-container>
<!-- END Hidden Content -->